var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolumeMuteIcon = function SvgVolumeMuteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.84 17.337H4.76c-1.52 0-2.76-1.24-2.76-2.76v-5.03a2.77 2.77 0 0 1 2.77-2.77h2.08c.41 0 .75.34.75.75v9.06c0 .41-.34.75-.75.75zm-2.07-9.06c-.7 0-1.27.57-1.27 1.27v5.03c0 .7.57 1.26 1.26 1.26h1.33v-7.56H4.76z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.54 21.078c-.25 0-.51-.08-.72-.23l-5.41-3.81a.753.753 0 1 1 .87-1.23l5.01 3.53v-14.6l-5.01 3.53a.753.753 0 1 1-.87-1.23l5.41-3.81c.38-.27.88-.3 1.3-.09.41.21.66.62.66 1.08v15.64c0 .45-.25.87-.66 1.08-.18.1-.38.14-.58.14M21.25 15.148c-.19 0-.38-.07-.53-.22l-4.8-4.72c-.3-.29-.3-.77 0-1.06.29-.3.77-.3 1.06 0l4.8 4.72c.3.29.3.77 0 1.06-.15.15-.34.22-.53.22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.45 15.148c-.19 0-.39-.07-.53-.22a.754.754 0 0 1 0-1.06l4.8-4.72c.3-.29.77-.29 1.06 0 .29.3.29.77 0 1.06l-4.8 4.72c-.15.14-.34.22-.53.22"
  })));
};
export default SvgVolumeMuteIcon;